<div class="container">
    <div class="row">
        <div class="col-md-8 mr-auto ml-auto">
            <h2 class="title">{{'reserves.myCommissions'|traduccion}}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header">
                    <div class="float-left"></div>
                    <div class="float-right"></div>
                </div>
                <div class="card-body">


                    <mat-card class="invoicing-card">
                    
                        <div class="header-grid">
                            <div class="header-item">
                                <h4>{{'myCommissions.nextPayment.title'|traduccion}}</h4>
                                <p class="amount">{{myCommissions.nextPayment|currency: 'EUR'}}</p>
                                <small><mat-icon>info</mat-icon> {{'myCommissions.nextPayment.info'|traduccion}}</small>
                            </div>
                    
                            <div class="header-item">
                                <h4>{{'myCommissions.lastPayment.title'|traduccion}}</h4>
                                <p class="amount">{{myCommissions.lastPayment|currency: 'EUR'}}</p>
                            </div>
                    
                            <div class="header-item enquiries">
                                <h4>{{'myCommissions.requestPayment.title'|traduccion}}</h4>
                                <p>{{'myCommissions.requestPayment.info'|traduccion}}</p>
                                <div class="actions">
                                    <button mat-raised-button color="primary" (click)="openInvoiceDialog()">
                                        {{'myCommissions.requestPayment.button'|traduccion}}
                                    </button>
                                    <button mat-raised-button color="primary" (click)="commissionTransfer()" [disabled]="myCommissions.nextPayment==0">
                                        {{'myCommissions.transferWallet.button'|traduccion}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    
                    
                        <div class="distribution">
                            <h4>{{'myCommissions.distribution.title'|traduccion}}</h4>
                            <div>
                                <p>{{'myCommissions.distribution.opcions'|traduccion}}</p>
                                <ul>
                                    <li [innerHTML]="'myCommissions.distribution.opcions.1'|traduccion"></li>
                                    <li [innerHTML]="'myCommissions.distribution.opcions.2'|traduccion"></li>
                                </ul>
                                <div class="actions">
                                    <button mat-raised-button color="primary" (click)="openAuxDialog('Obtener enlace', '')">
                                        {{'Compartir'|traduccion}}
                                    </button>
                                </div>
                            </div>
                        </div>


                        <mat-form-field appearance="outline" class="filter-input">
                            <mat-label>{{'myCommissions.filter'|traduccion}}</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="{{'myCommissions.filter.placeholder'|traduccion}}">
                        </mat-form-field>

                        <table mat-table [dataSource]="commissions" class="mat-elevation-z2 full-width-table">
                    
                            <!-- Date -->
                            <ng-container matColumnDef="createdAt">
                                <th mat-header-cell *matHeaderCellDef>{{'myCommissions.date'|traduccion}}</th>
                                <td mat-cell *matCellDef="let element">{{ element.createdAt | date: appService.FORMAT_DATE }}</td>
                            </ng-container>
                    
                            <!-- Amount -->
                            <ng-container matColumnDef="totalPurchased">
                                <th mat-header-cell *matHeaderCellDef>{{'myCommissions.totalPurchased'|traduccion}}</th>
                                <td mat-cell *matCellDef="let element">{{ element.totalPurchased|currency:'EUR' }}</td>
                            </ng-container>
                    
                            <!-- Commission -->
                            <ng-container matColumnDef="percentage">
                                <th mat-header-cell *matHeaderCellDef>{{'myCommissions.commission'|traduccion}}</th>
                                <td mat-cell *matCellDef="let element">{{ element.percentage }} %</td>
                            </ng-container>
                    
                            <!-- Status -->
                            <ng-container matColumnDef="liquidated">
                                <th mat-header-cell *matHeaderCellDef>{{'myCommissions.status'|traduccion}}</th>
                                <td mat-cell *matCellDef="let element">{{ element.liquidated ? ('myCommissions.status.true'|traduccion) : ('myCommissions.status.false'|traduccion) }}</td>
                            </ng-container>
                    
                            <!-- Invoice -->
                            <ng-container matColumnDef="invoice">
                                <th mat-header-cell *matHeaderCellDef>{{'myCommissions.invoice'|traduccion}}</th>
                                <td mat-cell *matCellDef="let element">{{ element.invoice || '-' }}</td>
                            </ng-container>
                    

                            <!-- Header y filas -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                                    <div class="empty-state">
                                        <div class="empty-state__pulse"></div>
                                        <h4>Empieza a generar tus primeras comisiones</h4>
                                        <p>Aqui veras el historial cuando alguien reserve desde tu enlace o use tu codigo descuento. Comparte tu acceso y activa tus comisiones.</p>
                                    </div>
                                </td>
                            </tr>

                        </table>

                        <!-- 📑 Paginador -->
                        <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
                    

                    </mat-card>

                </div>
            </div>
        </div>
    </div>
</div>
